import { appSettings } from "../app-settings";

export const useSettings = () => appSettings;
